export type formatStoryTypeProps = (urn?: string) => string;

export const formatStoryType: formatStoryTypeProps = (urn = '') => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_surn, _xing, namespace = '', table = ''] = urn.split(':');

  return `${namespace}:${table}`;
};
